module.exports = "/_next/static/images/Recovery-f89db972d4365f1163d2936c5ac0a181.png";